<template>
  <b-row>
    <b-col sm="2">
      <h6><strong>Valor da Dívida</strong></h6>
      <h3>{{ valorBr(total.totalNominal, true) }}</h3>
    </b-col>
    <b-col sm="2">
      <h6><strong>{{ juros }}% Juros</strong></h6>
      <h3>{{ valorBr(total.totalJuros, true) }}</h3>
    </b-col>
    <b-col sm="2">
      <h6><strong>{{ multa }}% Multa</strong></h6>
      <h3>{{ valorBr(total.totalMulta, true) }}</h3>
    </b-col>
    <b-col sm="2">
      <h6>
        <strong>&asymp; {{ honorarios }}% Hon. Variável</strong>
      </h6>
      <h3>{{ valorBr(total.totalHonorario, true) }}</h3>
    </b-col>
    <b-col sm="2">
      <h6>
        <strong>{{ desconto }}% Desconto{{ descontoNominal ? ' Nominal' : '' }}</strong>
      </h6>
      <h3>{{ valorBr(total.totalDesconto, true) }}</h3>
    </b-col>

    <b-col sm="2">
      <h6><strong>Valor da Negociação</strong></h6>
      <h3>{{ valorBr(valorTotalComTaxaCartao, true) }}</h3>
    </b-col>

    <b-col
      v-if="parametroDefault &&
        parametroDefault.taxaCartao &&
        parametroDefault.taxaCartao > 0 &&
        parametroDefault.opcao_pagamento &&
        parametroDefault.opcao_pagamento.key === 'cliente' &&
        $store.state.negociar.formaPagamento &&
        $store.state.negociar.formaPagamento.key === 'cartao_voz'"
      sm="2"
      class="mt-1"
    >
      <h6><strong>{{ parametroDefault.taxaCartao }}% Taxa Cartão *</strong></h6>
      <!-- <h3>
        {{ parametroDefault && parametroDefault.taxaCartao && parametroDefault.opcao_pagamento && parametroDefault.opcao_pagamento.key === 'cliente'
          ? valorBr((total.valorTotal * (parseFloat(parametroDefault.taxaCartao) / 100)), true)
          : valorBr(0, true) }}
      </h3> -->
      <h3>{{ valorBr(calcularTaxaCartaoComposta(total.valorTotal, parametroDefault.taxaCartao), true) }}</h3>
    </b-col>

  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
} from 'bootstrap-vue'
import { mapState } from 'vuex'

export default {
  components: {
    BRow,
    BCol,
  },
  computed: {
    ...mapState({
      juros: state => state.negociar.negociacao.juros,
      multa: state => state.negociar.negociacao.multa,
      honorarios: state => state.negociar.negociacao.honorarios,
      desconto: state => state.negociar.negociacao.desconto,
      descontoNominal: state => state.negociar.descontoNominal,
      operacoesSelected: state => state.negociar.operacoesSelected,
      total: state => state.negociar.totais,
      parametroDefault: state => state.negociar.parametroDefault,
    }),
    // valorTotalComTaxaCartao() {
    //   // Valor base corrigido
    //   let valorBase = this.total.valorTotal
    //   // Se existir taxaCartao e opcao_pagamento for 'cliente', acrescenta a taxa
    //   if (
    //     this.parametroDefault
    //     && this.parametroDefault.taxaCartao
    //     && this.parametroDefault.opcao_pagamento
    //     && this.parametroDefault.opcao_pagamento.key === 'cliente'
    //   ) {
    //     const taxa = parseFloat(this.parametroDefault.taxaCartao) / 100
    //     valorBase += (valorBase * taxa)
    //   }
    //   return valorBase
    // },
    valorTotalComTaxaCartao() {
      return this.$store.getters['negociar/valorTotalComTaxa']
    },
  },
  methods: {
    calcularTaxaCartaoComposta(valorBase, taxaCartao) {
      const taxa = parseFloat(taxaCartao.toString().replace(',', '.')) / 100
      // Calcula o valor final (o que o cliente vai pagar)
      // valorFinal = valorBase / (1 - taxa)
      const valorFinal = valorBase / (1 - taxa)
      // A taxa é a diferença entre o valor final e o valor base
      const taxaCartaoValor = valorFinal - valorBase
      return taxaCartaoValor
    },
  },
}
</script>
